export default __webpack_public_path__ + "static/media/wi_02d_few_clouds.8f7703be.svg";